import React from 'react';

export default function LoadMoreButton({ loadMoreItems }) {
    return (
        <button
            onClick={loadMoreItems}
            className="uppercase text-base text-black font-semibold border border-black py-2.5 px-32 text-center mx-auto block my-10 xl:my-12"
        >
            Load More
        </button>
    );
}
